<template>
  <section class="featured-jobs">
    <div class="container">
      <div class="row" data-aos="fade-up">
        <div class="col-md-12">
          <div class="heading">
            <h2>{{ $t('hot-jobs.title') }}</h2>
            <p style="float:right"><router-link to="/jobs">更多 →</router-link></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6 col-xs-6 res" v-for="job in jobs">
          <JobBox :job="job" :config="config" />
        </div>
      </div>
    </div>
  </section>
</template>
<style>
@media only screen and (max-width:480px) {
  .res {
    padding: 0 5px;
  }
}
</style>

<script>
// @ is an alias to /src
import JobBox from '@/components/JobBox.vue'

export default {
  name: 'HotJobs',
  props: ['jobs', 'config'],
  components: {
    JobBox
  },
  created: function() {
    //console.log(this.$i18n.locale)
  }
}
</script>
